import { form, React } from "aaa";

// FormsyCheckbox ignores validationError strings -> add this functionality
export class FormsyCheckboxWithValidation extends React.Component<
    { validations: string; submitted: boolean; validationError: string } & any, // props
    { checked: boolean } // state
> {
    constructor(props: any) {
        super(props);
        this.state = { checked: false };
    }

    render() {
        return (
            <div>
                <form.FormsyCheckbox
                    {...this.props}
                    onChange={(event: any, value: boolean) => {
                        this.setState({ checked: value });
                    }}
                />
                {((this.props.validations === "isTrue" && !this.state.checked) || (this.props.validations === "isFalse" && this.state.checked)) && this.props.submitted && (
                        <div style={{ color: "#F44336", fontSize: 12, fontHeight: 12, marginTop: 4}}>
                            {this.props.validationError}
                        </div>
                    )}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/util/FormsyCheckboxWithValidation.tsx